import apiClient from './client';

// Control Panel Platform Status Page
export const getControlPanelStatusPage = () => apiClient.get('/control-panel/status-page/');

// Control Panel Crawl Status Page
export const getFailedJobs = (fromDate, toDate) => apiClient.get(`/control-panel/failed-jobs?from_date=${fromDate}&to_date=${toDate}`);
export const updateFailedJobs = (data) => apiClient.post(`/control-panel/failed-jobs/`, data);

// Crawl Cost Estimator
export const getCrawlCostEstimator = (domain, frequency, numProducts) => apiClient.get(`/control-panel/proxy-cost-calculator/?domain=${domain}&frequency=${frequency}&num_urls=${numProducts}`);

// Spider Library
export const getSpiderLibrary = () => apiClient.get('/spider-library/');
export const updateSpiderLibrary = (data) => apiClient.post('/spider-library/update/', data);

// Spider Scheduling
export const getExistingSpiderSchedules = () => apiClient.get('/spider-library/scheduling/');
export const getPortalSpiderSchedules = () => apiClient.get('/spider-library/portal-scheduler/');
export const getPortalSpiderScheduleLogs = () => apiClient.get('/spider-library/portal-scheduler/logs/');
export const kickoffSpiderSchedules = (data) => apiClient.post('/spider-library/scheduling/', data);
export const updatePortalSchedule = (data) => apiClient.post('/spider-library/portal-scheduler/', data);
export const deletePortalSchedule = (scheduleId) => apiClient.delete('/spider-library/portal-scheduler/', {data: [{schedule_id: scheduleId}]});

// Bulk Search Crawl Kickoff
export const getSearchCrawlKickedOffJobs = () => apiClient.get('/search-crawler/bulk-search-crawl-kickoff/');
export const kickoffBulkSearchCrawl = (data) => apiClient.post('/search-crawler/bulk-search-crawl-kickoff/', data);
// Search Crawl Scheduling
export const getSearchCrawlSchedules = () => apiClient.get('/search-crawler/bulk-search-crawl-scheduling/');
export const updateSearchCrawlSchedule = (data) => apiClient.post('/search-crawler/bulk-search-crawl-scheduling/', data);
export const deleteSearchCrawlSchedule = (scheduleId) => apiClient.delete('/search-crawler/bulk-search-crawl-scheduling/', {data: [{schedule_id: scheduleId}]});

// Search Crawl Monitoring
export const getSearchCrawlMonitoring = () => apiClient.get('/search-crawler/monitoring/');

// Search Crawl Match Review
export const getSearchCrawlMatchReview = (url) => apiClient.post('/search-crawler/results/', {'zyte_url' : url});
export const getSearchCrawlVerticals = () => apiClient.get('/search-crawler/');
export const updateSearchCrawlMatchReview = (data) => apiClient.post('/search-crawler/update-match-review/', data);
export const kickoffAIMatchReview = (data) => apiClient.post('/search-crawler/ai-match-review/', data);